import {Component, Inject, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {ProleisSuppliersState} from '../../store/store.index';
import {ActivatedRoute} from '@angular/router';
import {IncidentsActions, IncidentsSelectors} from '../../store/incidents/incidents.index';
import {Observable} from 'rxjs';
import {OrdersActions, OrdersSelectors} from '../../store/orders/orders.index';
import {PositionActions, PositionSelectors} from '../../store/positions/position.index';
import {APP_GUIDS, AppGuids} from '../../../app.guids';
import {SearchPositionDialogComponent} from '../../orders/search-position/search.position.dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ProleisObject} from "@proleis/proleis-rest-client";
import {CurrentViewService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-incidents-list',
  templateUrl: 'incidents.list.component.html',
  styleUrls: ['incidents.list.component.scss']
})
export class IncidentsListComponent implements OnInit {

  incidents: Observable<ProleisObject[]>;
  order$: Observable<ProleisObject>;
  position$: Observable<ProleisObject>;

  aliasFields = 'SNR=LINK_ID.PARENTANDMYSELF[TYP_ID.GUID=' + this.appGuids.GUID_TEILE_TYP + '].NAME;' +
    'ORDERNR=LINK_ID.PARENTANDMYSELF[TYP_ID.GUID=' + this.appGuids.GUID_TEILE_TYP + '].CHILD[TYP_ID.GUID=' +
    this.appGuids.GUID_PSETYP_TB + '].PBO_BESTELL_POS_ID.PARENT.NAME;CATEGORYNAME=HAUPTKATEGORIE_ID.NAME;ERRORNAME=KATEGORIE_ID.NAME' +
    ';PRIONAME=PRIO.TEXT;STATUSNAME=PROBLEM_STATUS_ID.NAME;STATUSGUID=PROBLEM_STATUS_ID.GUID';

  constructor(private store: Store<ProleisSuppliersState>, private route: ActivatedRoute, @Inject(APP_GUIDS) private appGuids: AppGuids,
              private matDialog: MatDialog, public cvs: CurrentViewService) {
  }

  ngOnInit() {
    this.store.dispatch(IncidentsActions.LOAD_INCIDENTS({
      orderId: this.route.snapshot.params.id,
      posId: this.route.snapshot.params.posId,
      aliasFields: this.aliasFields
    }));

    this.store.dispatch(OrdersActions.LOAD_ORDER({
      orderId: this.route.snapshot.params.id
    }));

    this.store.dispatch(PositionActions.LOAD_POSITION({
      pboId: this.route.snapshot.params.id,
      posId: this.route.snapshot.params.posId
    }));

    this.order$ = this.store.select(OrdersSelectors.selectOrder);
    this.incidents = this.store.select(IncidentsSelectors.selectIncidents);
    this.position$ = this.store.select(PositionSelectors.selectPosition);
  }

  getStatusStyle(incident: ProleisObject): string {
    if (incident.EXT_QS_CHANGE_NOTICE) {
      return 'status-changed';
    }
    switch (incident.STATUSGUID) {
      case this.appGuids.GUID_INCIDENT_STATUS_OPEN:
        return 'status-open';
      case this.appGuids.GUID_INCIDENT_STATUS_ACCEPTED:
        return 'status-accepted';
      default:
        return 'status-open';
    }
  }

  isOpen(incident: ProleisObject) {
    return incident.STATUSGUID === this.appGuids.GUID_INCIDENT_STATUS_OPEN;
  }

  acceptIncident(incident: ProleisObject) {
    this.store.dispatch(IncidentsActions.ACCEPT_INCIDENT({
      orderId: this.route.snapshot.params.id,
      posId: this.route.snapshot.params.posId,
      incidentId: incident.OBJECT_ID,
      aliasFields: this.aliasFields
    }));

  }

  acceptNotice(incident: ProleisObject) {
    this.store.dispatch(IncidentsActions.INCIDENT_ACCEPT_CHANGE({
      incidentId: incident.OBJECT_ID,
      posId: this.route.snapshot.params.posId,
      orderId: this.route.snapshot.params.id,
      aliasFields: this.aliasFields
    }));
  }

  openSearchDialog() {
    this.matDialog.open(SearchPositionDialogComponent);
  }

}
